import { ACTION_TYPE } from '../actions/actionTypes';

const { ID_PASSPORT } = ACTION_TYPE;

const idPassportReducer = (state = {}, action) => {
  switch (action.type) {
    case ID_PASSPORT.UPDATE_ID_PASSPORT_DATA:
      return { ...state, [action.payload.name]: action.payload.value };
    case ID_PASSPORT.FETCH_ID_PASSPORT:
      return {
        ...state,
        fullName: action.payload.fullName,
        civilId: action.payload.civilId,
        passportId: action.payload.passportId,
        selfie: action.payload.selfie,
        civilIdFront: action.payload.civilIdFront,
        civilIdBack: action.payload.civilIdBack,
        passport: action.payload.passport,
        tobeEmailed: action.payload.tobeEmailed,
        isWithCivilId: action.payload.isWithCivilId,
      };
    default:
      return state;
  }
};

export default idPassportReducer;
